import React from 'react';

function ChatMessRight({ isSelf, text, created_at }) {
  return (
    <div>
      <div className="chat-message">
        <div className="flex items-center justify-end ">
          <div className="flex flex-col space-y-2 text-xs max-w-xs mx-2 order-1 items-end">
            <span style={{ ...(isSelf && { background: 'rgba(0,178,164,0.2)' }) }} className={`px-4 py-2 rounded-lg inline-block text-gray-500 ${!isSelf ? 'bg-gray-light' : ''}`}>
              {text}
            </span>
            <div className="text-xs text-gray-400 flex justify-end tracking-tight gap-1 leading-3 mt-1" style={{ fontSize: '10px' }}>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-3 h-3">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </span>
              <span>{created_at}</span>
            </div>
          </div>
          {!isSelf && (
            <div className="w-6 h-6 rounded-full order-1" style={{ border: '1px solid rgb(229, 231, 235)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 24 24">
                <path fill="rgba(0,0,0,0.6)" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4"></path>
              </svg>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChatMessRight;
